import { useState, useEffect } from 'react';

interface WindowSize {
    width: number;
    height: number;
}

export const useWindowSize = (): WindowSize => {
    // 초기값 설정 (SSR 고려)
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: typeof window !== 'undefined' ? window.innerWidth : 0,
        height: typeof window !== 'undefined' ? window.innerHeight : 0,
    });

    useEffect(() => {
        // 리사이즈 핸들러 함수
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        // 초기 윈도우 사이즈 설정
        handleResize();

        // 이벤트 리스너 등록
        window.addEventListener('resize', handleResize);

        // 클린업 함수
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return windowSize;
};